const Shopify = window.Shopify

const SELECTORS = {
  PRICE: '[data-product-price]',
  PRICE_TEXT: '[data-product-price-text]',
  SELECT: '#ProductSelect',
  ADD: '#AddToCart',
  ADD_TEXT: '#AddToCartText',
}

const DISABLED_CLASS = 'product__btn-add--is-disabled'

export default (variant, selector) => {

  if (typeof Shopify === 'undefined') {
    console.warn('selectCallback depends on global Shopify')
    return
  }

  if (variant) {
    updateAddButton(variant.available)
    updatePrice(variant.price, variant.compare_at_price)
  } else {
    updateAddButton(false, false)
  }
}

function updatePrice(price, compareAtPrice = 0) {
  const formattedPrice = Shopify.formatMoney(price, '')
  const formattedCompareAtPrice = Shopify.formatMoney(compareAtPrice, '')

  if (compareAtPrice > price) {
    $(SELECTORS.PRICE_TEXT).html(`
      <s class="product__price--compare">${formattedCompareAtPrice}</s>
      <span class="product__price--is-on-sale">${formattedPrice}</span>
    `)
  } else {
    $(SELECTORS.PRICE_TEXT).text(formattedPrice)
  }
}

function updateAddButton(available, exists = true) {
  if (available && exists) {
    $(SELECTORS.ADD).removeClass(DISABLED_CLASS).removeAttr('disabled')
    $(SELECTORS.ADD_TEXT).text('Add to Bag')
  } else if (!available && exists) {
    $(SELECTORS.ADD).addClass(DISABLED_CLASS).attr('disabled', 'disabled')
    $(SELECTORS.ADD_TEXT).text('Sold Out')
  } else {
    $(SELECTORS.ADD).addClass(DISABLED_CLASS).attr('disabled', 'disabled')
    $(SELECTORS.ADD_TEXT).text('Unavailable')
  }
}



// WEBPACK FOOTER //
// ./product-select.js